document.documentElement.classList.add('js');

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (!toggle) return;
  const nav = document.querySelector('[data-mobile-nav]');
  const open = toggle.getAttribute('aria-expanded') === 'true';
  toggle.setAttribute('aria-expanded', String(!open));
  nav?.toggleAttribute('data-open', !open);
  nav?.classList.toggle('open', !open);
  const openLabel = toggle.dataset.openLabel || toggle.textContent;
  const closeLabel = toggle.dataset.closeLabel || openLabel;
  toggle.textContent = open ? openLabel : closeLabel;
});

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-collection-trigger]');
  const activeDropdown = event.target.closest('[data-collection-dropdown]');
  document.querySelectorAll('[data-collection-dropdown]').forEach((dropdown) => {
    const button = dropdown.querySelector('[data-collection-trigger]');
    if (!button) return;
    if (trigger && dropdown === activeDropdown) {
      const shouldOpen = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(shouldOpen));
      dropdown.toggleAttribute('data-open', shouldOpen);
      dropdown.classList.toggle('open', shouldOpen);
    } else if (!activeDropdown || dropdown !== activeDropdown) {
      button.setAttribute('aria-expanded', 'false');
      dropdown.removeAttribute('data-open');
      dropdown.classList.remove('open');
    }
  });
});

document.addEventListener('click', (event) => {
  const navLink = event.target.closest('[data-mobile-nav] a');
  if (!navLink) return;
  document.querySelectorAll('[data-collection-dropdown]').forEach((dropdown) => {
    dropdown.removeAttribute('data-open');
    dropdown.classList.remove('open');
    dropdown.querySelector('[data-collection-trigger]')?.setAttribute('aria-expanded', 'false');
  });
  const nav = document.querySelector('[data-mobile-nav]');
  nav?.removeAttribute('data-open');
  nav?.classList.remove('open');
  const menuToggle = document.querySelector('[data-menu-toggle]');
  if (menuToggle) {
    menuToggle.setAttribute('aria-expanded', 'false');
    menuToggle.textContent = menuToggle.dataset.openLabel || menuToggle.textContent;
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('[data-collection-dropdown]').forEach((dropdown) => {
    dropdown.removeAttribute('data-open');
    dropdown.classList.remove('open');
    dropdown.querySelector('[data-collection-trigger]')?.setAttribute('aria-expanded', 'false');
  });
  const menuToggle = document.querySelector('[data-menu-toggle]');
  if (menuToggle) {
    menuToggle.setAttribute('aria-expanded', 'false');
    menuToggle.textContent = menuToggle.dataset.openLabel || menuToggle.textContent;
  }
});

document.addEventListener('click', (event) => {
  const saveButton = event.target.closest('[data-product-save]');
  if (!saveButton) return;
  const isSaved = saveButton.getAttribute('aria-pressed') === 'true';
  saveButton.setAttribute('aria-pressed', String(!isSaved));
  saveButton.classList.toggle('active', !isSaved);
  const icon = saveButton.querySelector('span');
  if (icon) icon.textContent = isSaved ? '♡' : '♥';
  const label = saveButton.querySelector('b');
  if (label) label.textContent = isSaved ? (saveButton.dataset.saveLabel || label.textContent) : (saveButton.dataset.savedLabel || label.textContent);
});

const productGalleryState = new WeakMap();

const productGalleryReducedMotion = () => window.matchMedia?.('(prefers-reduced-motion: reduce)').matches === true;

const updateProductGallery = (gallery, requestedIndex) => {
  const state = productGalleryState.get(gallery);
  if (!state || state.items.length === 0) return;

  const index = Math.max(0, Math.min(requestedIndex, state.items.length - 1));
  state.index = index;

  state.items.forEach((item, itemIndex) => {
    item.setAttribute('aria-hidden', String(itemIndex !== index));
  });

  state.thumbnails.forEach((button, buttonIndex) => {
    const selected = buttonIndex === index;
    button.classList.toggle('active', selected);
    button.setAttribute('aria-pressed', String(selected));
  });

  const selectedThumbnail = state.thumbnails[index];
  const thumbnailRail = selectedThumbnail?.parentElement;
  if (selectedThumbnail && thumbnailRail) {
    const targetLeft = selectedThumbnail.offsetLeft - (thumbnailRail.clientWidth - selectedThumbnail.clientWidth) / 2;
    thumbnailRail.scrollTo({ left: Math.max(0, targetLeft), behavior: productGalleryReducedMotion() ? 'auto' : 'smooth' });
  }

  if (state.counter) state.counter.textContent = `${index + 1} / ${state.items.length}`;
};

const scrollProductGalleryTo = (gallery, requestedIndex, behavior = 'smooth') => {
  const state = productGalleryState.get(gallery);
  if (!state || state.items.length === 0) return;

  const count = state.items.length;
  const index = ((requestedIndex % count) + count) % count;
  const item = state.items[index];
  const scrollBehavior = productGalleryReducedMotion() ? 'auto' : behavior;

  state.stage.scrollTo({ left: item.offsetLeft, behavior: scrollBehavior });
  updateProductGallery(gallery, index);
};

const nearestProductGalleryIndex = (stage, items) => {
  const viewportCenter = stage.scrollLeft + stage.clientWidth / 2;
  let nearestIndex = 0;
  let nearestDistance = Number.POSITIVE_INFINITY;

  items.forEach((item, index) => {
    const itemCenter = item.offsetLeft + item.offsetWidth / 2;
    const distance = Math.abs(itemCenter - viewportCenter);
    if (distance < nearestDistance) {
      nearestDistance = distance;
      nearestIndex = index;
    }
  });

  return nearestIndex;
};

const initProductGallery = (gallery) => {
  if (gallery.dataset.carouselReady === 'true') return;

  const stage = gallery.querySelector('.product-gallery__stage');
  const items = [...gallery.querySelectorAll('[data-product-gallery-item]')];
  const thumbnails = [...gallery.querySelectorAll('[data-product-gallery-thumbnail]')];
  if (!stage || items.length === 0) return;

  gallery.dataset.carouselReady = 'true';
  items.forEach((item) => { item.hidden = false; });

  let carousel = stage.parentElement;
  if (!carousel?.classList.contains('product-gallery__carousel')) {
    carousel = document.createElement('div');
    carousel.className = 'product-gallery__carousel';
    stage.parentNode.insertBefore(carousel, stage);
    carousel.appendChild(stage);
  }

  const galleryLabel = gallery.querySelector('.product-gallery__thumbnails')?.getAttribute('aria-label') || 'Product image gallery';
  stage.setAttribute('role', 'region');
  stage.setAttribute('aria-roledescription', 'carousel');
  stage.setAttribute('aria-label', galleryLabel);

  let counter = null;
  if (items.length > 1) {
    stage.tabIndex = 0;

    const previousButton = document.createElement('button');
    previousButton.type = 'button';
    previousButton.className = 'product-gallery__nav product-gallery__nav--prev';
    previousButton.dataset.productGalleryPrev = '';
    previousButton.setAttribute('aria-label', 'Previous product image');
    previousButton.innerHTML = '<span aria-hidden="true">\u2039</span>';

    const nextButton = document.createElement('button');
    nextButton.type = 'button';
    nextButton.className = 'product-gallery__nav product-gallery__nav--next';
    nextButton.dataset.productGalleryNext = '';
    nextButton.setAttribute('aria-label', 'Next product image');
    nextButton.innerHTML = '<span aria-hidden="true">\u203a</span>';

    counter = document.createElement('div');
    counter.className = 'product-gallery__counter';
    counter.setAttribute('aria-live', 'polite');
    counter.setAttribute('aria-atomic', 'true');

    carousel.append(previousButton, nextButton, counter);
  }

  const state = { stage, items, thumbnails, counter, index: 0, ticking: false };
  productGalleryState.set(gallery, state);
  updateProductGallery(gallery, 0);

  stage.addEventListener('scroll', () => {
    if (state.ticking) return;
    state.ticking = true;
    window.requestAnimationFrame(() => {
      updateProductGallery(gallery, nearestProductGalleryIndex(stage, items));
      state.ticking = false;
    });
  }, { passive: true });
};

const initProductGalleries = (root = document) => {
  root.querySelectorAll?.('[data-product-gallery]').forEach(initProductGallery);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initProductGalleries());
} else {
  initProductGalleries();
}

document.addEventListener('shopify:section:load', (event) => initProductGalleries(event.target));

document.addEventListener('click', (event) => {
  const thumbnail = event.target.closest('[data-product-gallery-thumbnail]');
  if (thumbnail) {
    const gallery = thumbnail.closest('[data-product-gallery]');
    if (!gallery) return;
    scrollProductGalleryTo(gallery, Number(thumbnail.dataset.productGalleryThumbnail));
    return;
  }

  const previousButton = event.target.closest('[data-product-gallery-prev]');
  if (previousButton) {
    const gallery = previousButton.closest('[data-product-gallery]');
    const state = gallery ? productGalleryState.get(gallery) : null;
    if (gallery && state) scrollProductGalleryTo(gallery, state.index - 1);
    return;
  }

  const nextButton = event.target.closest('[data-product-gallery-next]');
  if (nextButton) {
    const gallery = nextButton.closest('[data-product-gallery]');
    const state = gallery ? productGalleryState.get(gallery) : null;
    if (gallery && state) scrollProductGalleryTo(gallery, state.index + 1);
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
  const stage = event.target.closest?.('.product-gallery__stage');
  const gallery = stage?.closest('[data-product-gallery]');
  const state = gallery ? productGalleryState.get(gallery) : null;
  if (!gallery || !state || state.items.length < 2) return;

  event.preventDefault();
  scrollProductGalleryTo(gallery, state.index + (event.key === 'ArrowRight' ? 1 : -1));
});

document.addEventListener('click', (event) => {
  const tab = event.target.closest('[data-product-tab]');
  if (!tab) return;
  const tabs = tab.closest('[data-product-tabs]');
  if (!tabs) return;
  tabs.querySelectorAll('[data-product-tab]').forEach((button) => {
    const selected = button === tab;
    button.classList.toggle('active', selected);
    button.setAttribute('aria-selected', String(selected));
  });
  tabs.querySelectorAll('[data-product-panel]').forEach((panel) => {
    panel.hidden = panel.id !== tab.dataset.productTab;
  });
});
